import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { giveGetEligibilityBackend } from './give-get-eligibility.backend';
import { giveGetEligibilityReducer } from './give-get-eligibility.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('giveGetEligibility', giveGetEligibilityReducer),
    BackendModule.forFeature('giveGetEligibility', giveGetEligibilityBackend),
  ],
})
export class DatastoreGiveGetEligibilityModule {}



// WEBPACK FOOTER //
// ./src/@freelancer/datastore/give-get-eligibility/give-get-eligibility.module.ts